import Vue from 'vue'
import VueRouter from 'vue-router'
import Landing from '../views/Landing.vue'
import PageNotFound from '../views/PageNotFound.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '*',
    component: PageNotFound
  },
  {
    path: '/',
    component: Landing,
    children: [
      {
        path: '/',
        name: 'start',
        component: () => import('@/views/Start.vue')
      },
      {
        path: '/clients',
        name: 'clientsReport',
        component: () => import('@/views/Clients.vue')
      },
      {
        path: '/vales',
        name: 'reportVales',
        component: () => import('@/views/Report.vue')
      }
      // {
      //   path: '/contact',
      //   name: 'contact',
      //   component: () => import('@/views/NewEnterprise.vue')
      // },
      // {
      //   path: '/contactsuccess',
      //   name: 'contactsuccess',
      //   component: () => import('@/views/NewEnterpriseSuccess.vue')
      // },
      // {
      //   path: '/legal/terms',
      //   name: 'terms',
      //   component: () => import('@/views/legal/Terms.vue')
      // },
      // {
      //   path: '/legal/privacy',
      //   name: 'privacy',
      //   component: () => import('@/views/legal/Privacy.vue')
      // },
      // {
      //   path: '/resetpassword',
      //   name: 'resetpassword',
      //   component: () => import('@/views/ResetPassword.vue')
      // },
      // {
      //   path: '/resetpass/:code/:userid',
      //   name: 'resetpasswordconfirmation',
      //   props: true,
      //   component: () => import('@/views/ResetPasswordConfirmation.vue')
      // }
    ]
  },
  {
    path: '/principal',
    name: 'principal',
    component: () => import('@/views/Principal.vue'),
    children: [
      {
        path: '/principal/dashboard',
        name: 'dashboard',
        component: () => import('@/views/Dashboard.vue')
      },
      {
        path: '/principal/account',
        name: 'account',
        component: () => import('@/views/AccountSettings.vue')
      },
      {
        path: '/principal/reports',
        component: () => import('@/views/Reports.vue'),
        children: [
          {
            path: '/principal/reports',
            name: 'reports',
            component: () => import('@/components/reports/Dashboard.vue')
          },
          {
            path: '/principal/reports/compras',
            name: 'compras',
            component: () => import('@/components/reports/Compras.vue')
          },
          {
            path: '/principal/reports/compras/detail',
            name: 'compras.detail',
            component: () => import('@/components/reports/Detail.vue')
          },
          {
            path: '/principal/reports/users',
            name: 'reportsUsers',
            component: () => import('@/components/reports/Users.vue')
          },
          {
            path: '/principal/reports/enterprise',
            name: 'reportEnterprise',
            component: () => import('@/components/reports/Enterprise.vue')
          },
          {
            path: '/principal/reports/tickets',
            name: 'reportTickets',
            component: () => import('@/components/reports/Tickets.vue')
          },
          {
            path: '/principal/reports/products',
            name: 'reportProducts',
            component: () => import('@/components/reports/Products.vue')
          },
          {
            path: '/principal/reports/utility',
            name: 'reportUtility',
            component: () => import('@/components/reports/Utility.vue')
          }
        ]
      },
      // Configuracion principal de conetenido CRM Mundo del catalogo
      {
        path: '/principal/providers',
        component: () => import('@/views/Providers.vue'),
        children: [
          {
            path: '/principal/providers',
            name: 'providers',
            component: () => import('@/components/providers/List.vue')
          },
          {
            path: '/principal/providers/add',
            name: 'addProviders',
            component: () => import('@/components/providers/Add.vue')
          },
          {
            path: '/principal/providers/parameters',
            name: 'providersParams',
            component: () => import('@/components/providers/Parameters.vue')
          }
        ]
      },
      {
        path: '/principal/warehouse',
        component: () => import('@/views/Warehouse.vue'),
        children: [
          {
            path: '/principal/warehouse',
            name: 'warehouse',
            component: () => import('@/components/warehouse/List.vue')
          },
          {
            path: '/principal/warehouse/add',
            name: 'addWarehouse',
            component: () => import('@/components/warehouse/Add.vue')
          },
          {
            path: '/principal/warehouse/products',
            name: 'productsWarehouse',
            component: () => import('@/components/warehouse/Products.vue')
          }
        ]
      },
      {
        path: '/principal/client',
        component: () => import('@/views/Client.vue'),
        children: [
          {
            path: '/principal/client',
            name: 'client',
            component: () => import('@/components/client/List.vue')
          },
          {
            path: '/principal/client/add',
            name: 'addclient',
            component: () => import('@/components/client/Add.vue')
          },
          {
            path: '/principal/client/info',
            name: 'infoClient',
            component: () => import('@/components/client/Config.vue')
          }
        ]
      },
      {
        path: '/principal/orders',
        component: () => import('@/views/Orders.vue'),
        children: [
          {
            path: '/principal/orders',
            name: 'orders',
            component: () => import('@/components/orders/Dashboard.vue')
          },
          {
            path: '/principal/orders/list',
            name: 'ordersList',
            component: () => import('@/components/orders/List.vue')
          },
          {
            path: '/principal/orders/add',
            name: 'addOrders',
            component: () => import('@/components/orders/Add2.vue')
          },
          {
            path: '/principal/orders/labels',
            name: 'labelsOrders',
            component: () => import('@/components/orders/Labels.vue')
          },
          {
            path: '/principal/orders/devolution',
            name: 'devolucionesCliente',
            component: () => import('@/components/orders/Devolutions.vue')
          }
        ]
      },
      {
        path: '/principal/buy',
        component: () => import('@/views/Compras.vue'),
        children: [
          {
            path: '/principal/buy',
            name: 'buy',
            component: () => import('@/components/buy/Dashboard.vue')
          },
          {
            path: '/principal/buy/list',
            name: 'buyList',
            component: () => import('@/components/buy/List.vue')
          },
          {
            path: '/principal/buy/almacen',
            name: 'buyListAlmacen',
            component: () => import('@/components/buy/ListAlmacen.vue')
          }
        ]
      },
      {
        path: '/principal/stocktaking',
        component: () => import('@/views/Stocktaking.vue'),
        children: [
          {
            path: '/principal/stocktaking',
            name: 'stocktaking',
            component: () => import('@/components/stocktaking/Dashboard.vue')
          },
          {
            path: '/principal/stocktaking/list',
            name: 'stocktakingList',
            component: () => import('@/components/stocktaking/List.vue')
          },
          {
            path: '/principal/stocktaking/listProvider',
            name: 'stocktakingListProvider',
            component: () => import('@/components/stocktaking/ListProviders.vue')
          }
          // {
          //   path: '/principal/buy/add',
          //   name: 'addbuy',
          //   component: () => import('@/components/buy/Add.vue')
          // }
        ]
      },
      {
        path: '/principal/sales',
        component: () => import('@/views/Sales.vue'),
        children: [
          {
            path: '/principal/sales',
            name: 'sales',
            component: () => import('@/components/sales/Dashboard.vue')
          },
          {
            path: '/principal/sales/list',
            name: 'salesList',
            component: () => import('@/components/sales/List.vue')
          },
          {
            path: '/principal/sales/add',
            name: 'addsales',
            component: () => import('@/components/sales/Add.vue')
          }
        ]
      },
      //  Termina configuracion de crm Mundo del catalogo
      {
        path: '/principal/metrics',
        component: () => import('@/views/Metric.vue'),
        children: [
          {
            path: '/principal/metrics',
            name: 'metrics',
            component: () => import('@/components/metrics/Dashboard.vue')
          },
          {
            path: '/principal/metrics/utility',
            name: 'metrics-utility',
            component: () => import('@/components/metrics/Utility.vue')
          }
        ]
      },
      {
        path: '/principal/enterprises',
        component: () => import('@/views/Enterprises.vue'),
        children: [
          {
            path: '/principal/enterprises',
            name: 'enterprises',
            component: () => import('@/components/enterprises/List.vue')
          },
          {
            path: '/principal/enterprises/add',
            name: 'enterprisesAdd',
            component: () => import('@/components/enterprises/Add.vue')
          },
          {
            path: '/principal/enterprises/parameters',
            name: 'enterprisesParams',
            component: () => import('@/components/enterprises/Parameters.vue')
          }
        ]
      },
      {
        path: '/principal/receipts',
        component: () => import('@/views/Receipts.vue'),
        children: [
          {
            path: '/principal/receipts',
            name: 'receipts',
            component: () => import('@/components/receipts/List.vue')
          },
          {
            path: '/principal/receipts/process',
            name: 'receiptsProcess',
            component: () => import('@/components/receipts/Process.vue')
          }
        ]
      },
      {
        path: '/principal/users',
        component: () => import('@/views/Users.vue'),
        children: [
          {
            path: '/principal/users',
            name: 'users',
            component: () => import('@/components/users/List.vue')
          },
          {
            path: '/principal/users/add',
            name: 'usersAdd',
            component: () => import('@/components/users/Add.vue')
          },
          {
            path: '/principal/users/config',
            name: 'usersConfig',
            component: () => import('@/components/users/Edit.vue')
          }
        ]
      },
      {
        path: '/principal/roles',
        component: () => import('@/views/Roles.vue'),
        children: [
          {
            path: '/principal/roles',
            name: 'roles',
            component: () => import('@/components/roles/List.vue')
          },
          {
            path: '/principal/roles/add',
            name: 'rolesAdd',
            component: () => import('@/components/roles/Add.vue')
          },
          {
            path: '/principal/roles/edit',
            name: 'rolesEdit',
            component: () => import('@/components/roles/Edit.vue')
          }
        ]
      },
      {
        path: '/principal/modules',
        component: () => import('@/views/Modules.vue'),
        children: [
          {
            path: '/principal/modules',
            name: 'modules',
            component: () => import('@/components/modules/List.vue')
          },
          {
            path: '/principal/modules/add',
            name: 'modulesAdd',
            component: () => import('@/components/modules/Add.vue')
          },
          {
            path: '/principal/modules/permision',
            name: 'modulesPermissionAdd',
            component: () => import('@/components/modules/Permissions.vue')
          }
        ]
      },
      {
        path: '/principal/providerDevolutions',
        component: () => import('@/views/ProviderDevolutions.vue'),
        children: [
          {
            path: '/principal/providerDevolutions',
            name: 'providerDevolutions',
            component: () => import('@/components/providerDevolutions/Dashboard.vue')
          },
          {
            path: '/principal/genrealDevolutionsProvider',
            name: 'genrealDevolutionsProvider',
            component: () => import('@/components/providerDevolutions/Add.vue')
          },
          {
            path: '/principal/genrealDevolutionProvider',
            name: 'genrealDevolutionsList',
            component: () => import('@/components/providerDevolutions/List.vue')
          },
          {
            path: '/principal/genrealDevolutionProviderDates',
            name: 'genrealDevolutionsListDates',
            component: () => import('@/components/providerDevolutions/forDates.vue')
          },
          {
            path: '/principal/genrealDevolutionsDetail',
            name: 'genrealDevolutionsDetail',
            component: () => import('@/components/providerDevolutions/Detail.vue')
          }
        ]
      },
      {
        path: '/principal/settings',
        component: () => import('@/views/Settings.vue'),
        children: [
          {
            path: '/principal/settings/general',
            name: 'settingsGeneral',
            component: () => import('@/components/settings/General.vue')
          },
          {
            path: '/principal/settings/members',
            name: 'settingsMembers',
            component: () => import('@/components/settings/Members.vue')
          },
          {
            path: '/principal/settings/log',
            name: 'settingsAuditLog',
            component: () => import('@/components/settings/AuditLog.vue')
          }
        ]
      },
      {
        path: '/principal/contracts',
        component: () => import('@/views/Contracts.vue'),
        children: [
          {
            path: '/principal/contracts',
            name: 'contracts',
            component: () => import('@/components/contracts/List.vue')
          },
          {
            path: '/principal/contracts/info',
            name: 'contractsInfo',
            component: () => import('@/components/contracts/Info.vue')
          }
          // {
          //   path: '/principal/settings/members',
          //   name: 'settingsMembers',
          //   component: () => import('@/components/settings/Members.vue')
          // },
          // {
          //   path: '/principal/settings/log',
          //   name: 'settingsAuditLog',
          //   component: () => import('@/components/settings/AuditLog.vue')
          // }
        ]
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
